module.exports = __webpack_public_path__ + "media/common/images/review_2-5357f8ea9a25f1d7b0258cb483827f27.png";